import { createContext, useState } from 'react'

import {
  IReportsPaginatedResponse,
  IReportsResumeResponse,
} from '../../sdk/reports/reports.types'
import { sdk } from '../../services/sdk'

interface ReportsDataContext {
  loading: boolean
  reportResponse: IReportsPaginatedResponse | null
  reportFile: string | null
  reportsResume: IReportsResumeResponse[] | null
  actions: {
    getReport: (type: string, page?: number, limit?: number) => Promise<void>
    getReportsResume: () => Promise<void>
  }
}

interface ReportsProviderProps {
  children: React.ReactNode
}

export const ReportsContext = createContext({} as ReportsDataContext)

export function ReportsProvider(props: ReportsProviderProps) {
  const [loading, setLoading] = useState(false)
  const [reportResponse, setReportResponse] =
    useState<IReportsPaginatedResponse | null>(null)
  const [reportFile, setReportFile] = useState<string | null>(null)
  const [reportsResume, setReportsResume] = useState<
    IReportsResumeResponse[] | null
  >(null)

  const getReportsResume = async () => {
    try {
      setLoading(true)
      const response = await sdk.reports.reportsResume()
      setReportsResume(response)
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }

  const getReport = async (type: string, page = 1, limit?: number) => {
    try {
      const response = await sdk.reports.getReport(type, page, limit)
      setReportResponse(response)

      const fileResponse = await sdk.reports.getReportFile(type)
      setReportFile(fileResponse.link)
    } catch (err) {}
  }

  return (
    <ReportsContext.Provider
      value={{
        loading,
        reportResponse,
        reportFile,
        reportsResume,
        actions: {
          getReport,
          getReportsResume,
        },
      }}
    >
      {props.children}
    </ReportsContext.Provider>
  )
}
